import { render, staticRenderFns } from "./FolderAssignWatcherDialog.vue?vue&type=template&id=2d9c9daa&scoped=true"
import script from "./FolderAssignWatcherDialog.vue?vue&type=script&lang=js"
export * from "./FolderAssignWatcherDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderAssignWatcherDialog.vue?vue&type=style&index=0&id=2d9c9daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c9daa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
